'use client';

import type { FC, ReactNode } from 'react';
import { STANCE_THEME, type StanceKey } from './stanceTheme';

export const StanceBadge: FC<{ stance: StanceKey; label: string }> = ({ stance, label }) => {
  const { ring, tint, Icon } = STANCE_THEME[stance];
  return (
    <span className="inline-flex items-center gap-1 whitespace-nowrap align-baseline">
      <span
        className="inline-flex h-[17px] w-[17px] items-center justify-center rounded-full border"
        style={{ borderColor: ring, background: `radial-gradient(circle at 35% 30%, ${tint[0]}, ${tint[1]})` }}
      >
        <Icon size={9} className="text-white" />
      </span>
      <span className="font-semibold" style={{ color: ring }}>{label}</span>
    </span>
  );
};

const TOKEN = /\[\[(attack|maneuver|defense)\|([^\]]+)\]\]/g;

const isStanceKey = (s: string): s is StanceKey => s in STANCE_THEME;

export const StanceText: FC<{ text: string }> = ({ text }) => {
  const out: ReactNode[] = [];
  let last = 0;
  for (const m of text.matchAll(TOKEN)) {
    const key = m[1];
    if (m.index > last) out.push(text.slice(last, m.index));
    out.push(isStanceKey(key) ? <StanceBadge key={m.index} stance={key} label={m[2]} /> : m[0]);
    last = m.index + m[0].length;
  }
  if (last < text.length) out.push(text.slice(last));
  return <>{out}</>;
};
